import { ParseTableConfig } from './config';
import { Property, TableType } from './types';

// See calculation logic in
// https://docs.google.com/spreadsheets/d/1SwstvZoCm1Pa4DMjY42cqGN-q-7brMi5RltjbVLl0KE/edit?gid=0#gid=0
export const DEFAULT_CONFIGS: Record<Property, Record<TableType, ParseTableConfig>> = {
  "三軒茶屋": {
    "收入": {
      displayName: "收入",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Smart Partners',
      headers: [
        { name: '号室', kind: 'metadata' },
        { name: '契約者', kind: 'metadata' },
        { name: '賃料', kind: 'numeric', account: '租金收入', includeInSum: true },
        { name: '管理費', kind: 'numeric', account: '管理費收入', includeInSum: true },
        { name: '毎月支払額', kind: 'metadata' },  // already accounted for in 賃料 and 管理費
        { name: '預かり清掃費', kind: 'numeric', account: '保證金', includeInSum: true },
        { name: '敷金', kind: 'numeric', account: '保證金', includeInSum: true },
        { name: '更新料', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '礼金', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '入金額', kind: 'metadata' },
        { name: '備考', kind: 'metadata' },
      ],
    },
    "其他收入": {
      displayName: "其他收入",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Smart Partners',
      headers: [
        { name: '番号', kind: 'metadata' },
        { name: '支付者', kind: 'metadata' },
        { name: '項目', kind: 'metadata' },
        { name: '支払額', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '源泉徴収税', kind: 'numeric', account: '源泉稅', includeInSum: true },
        { name: '入金額', kind: 'metadata' },
        { name: '備考', kind: 'metadata' },
      ],
    },
    "支出": {
      displayName: "支出",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Smart Partners',
      headers: [
        { name: '番号', kind: 'metadata' },
        { name: '受取者', kind: 'metadata' },
        { name: '項目', kind: 'metadata' },
        { name: '出金額', kind: 'numeric', account: '其他一次性運營費用', includeInSum: true },
        { name: '備考', kind: 'metadata' },
      ],
    },
  },
  "目黑": {
    "收入": {
      displayName: "收入",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Smart Partners',
      headers: [
        { name: '号室', kind: 'metadata' },
        { name: '契約者', kind: 'metadata' },
        { name: '賃料', kind: 'numeric', account: '租金收入', includeInSum: true },
        { name: '管理費', kind: 'numeric', account: '管理費收入', includeInSum: true },
        { name: '毎月支払額', kind: 'metadata' },  // already accounted for in 賃料 and 管理費
        { name: '源泉税', kind: 'numeric', account: '源泉稅', includeInSum: true },
        { name: '敷金', kind: 'numeric', account: '保證金', includeInSum: true },
        { name: '更新料', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '礼金', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '入金額', kind: 'metadata' },
        { name: '備考', kind: 'metadata' },
      ],
    },
    "其他收入": {
      displayName: "其他收入",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Smart Partners',
      headers: [
        { name: '番号', kind: 'metadata' },
        { name: '支付者', kind: 'metadata' },
        { name: '項目', kind: 'metadata' },
        { name: '支払額', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '源泉徴収税', kind: 'numeric', account: '源泉稅', includeInSum: true },
        { name: '入金額', kind: 'metadata' },
        { name: '備考', kind: 'metadata' },
      ],
    },
    "支出": {
      displayName: "支出",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Smart Partners',
      headers: [
        { name: '番号', kind: 'metadata' },
        { name: '受取者', kind: 'metadata' },
        { name: '項目', kind: 'metadata' },
        { name: '出金額', kind: 'numeric', account: '其他一次性運營費用', includeInSum: true },
        { name: '備考', kind: 'metadata' },
      ],
    },
  },
  "茅場町": {
    "收入": {
      displayName: "收入",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Smart Partners',
      headers: [
        { name: '号室', kind: 'metadata' },
        { name: '契約者', kind: 'metadata' },
        { name: '賃料', kind: 'numeric', account: '租金收入', includeInSum: true },
        { name: '共益費', kind: 'numeric', account: '管理費收入', includeInSum: true },
        { name: '消費税', kind: 'numeric', account: '消費稅', includeInSum: true },
        { name: '毎月支払額', kind: 'metadata' },  // already accounted for in 賃料 and 管理費
        { name: '源泉税', kind: 'numeric', account: '源泉稅', includeInSum: true },
        { name: '敷金', kind: 'numeric', account: '保證金', includeInSum: true },
        { name: '礼金', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '更新料', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '入金額', kind: 'metadata' },
        { name: '備考', kind: 'metadata' },
      ],
    },
    "其他收入": {
      displayName: "其他收入",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Smart Partners',
      headers: [
        { name: '番号', kind: 'metadata' },
        { name: '支付者', kind: 'metadata' },
        { name: '項目', kind: 'metadata' },
        { name: '入金額', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '備考', kind: 'metadata' },
      ],
    },
    "支出": {
      displayName: "支出",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Smart Partners',
      headers: [
        { name: '番号', kind: 'metadata' },
        { name: '受取者', kind: 'metadata' },
        { name: '項目', kind: 'metadata' },
        { name: '出金額', kind: 'numeric', account: '其他一次性運營費用', includeInSum: true },
        { name: '備考', kind: 'metadata' },
      ],
    },
  },
  "大井町": {
    "收入": {
      displayName: "收入",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Ichigo House',
      headers: [
        { name: 'EMPTY', kind: 'metadata' }, // 該当年月 in the original excel
        { name: '号室', kind: 'metadata' },  // テナント in the original excel
        { name: '契約者', kind: 'metadata' },  // 契約者名 in the original excel

        { name: '賃料', kind: 'numeric', account: '租金收入', includeInSum: true },
        { name: '共益費', kind: 'numeric', account: '管理費收入', includeInSum: true },
        { name: '駐車料', kind: 'numeric', account: '管理費收入', includeInSum: true },
        { name: '看板使用料', kind: 'numeric', account: '其他固定收入', includeInSum: true },

        { name: '敷金', kind: 'numeric', account: '保證金', includeInSum: true },
        { name: '礼金', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: 'その他', kind: 'numeric', account: '物件一次性收入', includeInSum: true },

        { name: '解約費・更新費', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: 'その他支払', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '控除', kind: 'numeric', account: '物件一次性收入', includeInSum: true },

        { name: '入金額', kind: 'metadata' },
        { name: '備考', kind: 'metadata' },
      ],
    },
    "其他收入": {
      displayName: "其他收入",
      range: 1,
      headers: [],
    },
    "支出": {
      displayName: "支出",
      range: 1,
      autoBalanceAccount: '帳戶-物管-Ichigo House',
      reverseSign: true,
      headers: [
        { name: 'EMPTY', kind: 'metadata' }, // 該当年月 in the original excel
        { name: '項目', kind: 'metadata' },  // 契約者名 in the original excel

        { name: '賃料', kind: 'numeric', account: '租金收入', includeInSum: true },
        { name: '共益費', kind: 'numeric', account: '管理費收入', includeInSum: true },
        { name: '駐車料', kind: 'numeric', account: '管理費收入', includeInSum: true },

        { name: 'その他', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '敷金', kind: 'numeric', account: '保證金', includeInSum: true },
        { name: '礼金', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: 'その他', kind: 'numeric', account: '物件一次性收入', includeInSum: true },

        { name: '解約費・更新費', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: 'その他支払', kind: 'numeric', account: '物件一次性收入', includeInSum: true },
        { name: '控除', kind: 'numeric', account: '其他一次性運營費用', includeInSum: true },

        { name: '出金額', kind: 'metadata' },  // 合計 in the original excel
        { name: '備考', kind: 'metadata' },
      ],
    },
  },
}
